import { ReactElement, useState } from 'react';

import { FilterPanel, Heading, StyledFlex } from '@dreryk/react-components';

import { translationKeys } from './translations';
import { WaitlistActionBar } from './actionBar/WaitlistActionBar';
import { WaitlistEntriesTable } from './table/WaitlistEntriesTable';
import { WaitlistEntryCreateModalOpener } from './create/WaitlistEntryCreateModal.opener';
import { WaitlistAddEntryAction } from './actionBar/WaitlistAddEntryAction';
import { WaitlistFilterPanel } from './filters/WaitlistFilterPanel';
import { WaitlistFilterPanelFormBean } from './filters/WaitlistFilterPanel.types';
import { WaitlistFilterPatientSearch } from './filters/patientSearch/WaitlistFilterPatientSearch';
import { WAITLIST_FILTER_PANEL_DEFAULT_VALUES } from './WaitlistPanel.constants';

export const WaitlistPanel = (): ReactElement => {
   const [patientSearchText, setPatientSearchText] = useState<string | null>(null);
   return (
      <FilterPanel.Provider<WaitlistFilterPanelFormBean>
         storageKeyPrefix={'egabinet-desktop'}
         defaultValues={WAITLIST_FILTER_PANEL_DEFAULT_VALUES}
      >
         <WaitlistActionBar>
            <StyledFlex gap={'18px'} direction={'column'}>
               <StyledFlex gap={'12px'}>
                  <Heading testId={'waitlist'} type={'h1'} content={translationKeys.waitlist} margin={'0px'} />
                  <StyledFlex justifyContent={'space-between'} flex={'1'}>
                     <WaitlistFilterPatientSearch onPatientSearchChanged={setPatientSearchText} />
                     <FilterPanel.VisibilitySwitch />
                  </StyledFlex>
               </StyledFlex>
               <WaitlistFilterPanel />
               <WaitlistEntriesTable patientSearchText={patientSearchText} />
            </StyledFlex>
            <WaitlistEntryCreateModalOpener>
               {({ openModal }) => <WaitlistAddEntryAction onClick={openModal} />}
            </WaitlistEntryCreateModalOpener>
         </WaitlistActionBar>
      </FilterPanel.Provider>
   );
};
